import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const BookCard = ({ book, index = 0 }) => {
  const levelColors = {
    entry: "bg-green-500/20 text-green-400 border-green-500/30",
    intermediate: "bg-blue-500/20 text-blue-400 border-blue-500/30",
    advanced: "bg-purple-500/20 text-purple-400 border-purple-500/30",
    practitioner: "bg-gold/20 text-gold border-gold/30",
  };

  return (
    <Link
      to={`/book/${book.id}`}
      className="book-card group block"
      data-testid={`book-card-${book.id}`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="relative overflow-hidden rounded-sm border border-white/5 bg-paper hover:border-gold/20 transition-colors duration-500">
        {/* Image */}
        <div className="aspect-[3/4] overflow-hidden bg-subtle">
          <img
            src={book.cover_image}
            alt={book.title}
            className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
        </div>

        {/* Content */}
        <div className="p-5">
          {/* Level Badge */}
          <span className={`inline-block px-2 py-0.5 text-xs uppercase tracking-wider rounded-sm border ${levelColors[book.reading_level]} mb-3`}>
            {book.reading_level}
          </span>

          {/* Title */}
          <h3 className="font-heading text-xl text-[#EAEAEA] mb-1 group-hover:text-gold transition-colors duration-300">
            {book.title}
          </h3>
          
          {book.subtitle && (
            <p className="font-heading text-sm text-[#A1A1AA] italic mb-3">
              {book.subtitle}
            </p>
          )}

          {/* Short Description */}
          <p className="text-[#A1A1AA] text-sm leading-relaxed mb-4 line-clamp-2">
            {book.short_description}
          </p>

          {/* Footer */}
          <div className="flex items-center justify-between pt-3 border-t border-white/5">
            {book.price === 0 ? (
              <span className="font-mono text-gold text-lg uppercase tracking-wider">
                Free
              </span>
            ) : (
              <span className="font-mono text-gold text-lg">
                ${book.price.toFixed(2)}
              </span>
            )}
            <span className="flex items-center gap-1 text-[#A1A1AA] text-sm group-hover:text-gold transition-colors duration-300">
              View <ArrowRight size={14} className="transform group-hover:translate-x-1 transition-transform duration-300" />
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default BookCard;
